import BaseRoute from "../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class MedicalRecordsCasesDetailRoute extends BaseRoute {
  @service("repositories/case-repository") caseRepository;
  @service("repositories/case-notes-repository") caseNotesRepository;

  id = "medical-records-cases-detail";
  path = ":id";
  element = (<Template />);
  revalidateOnQueryKeys = ["caseNoteLimit", "caseNoteSearch"];
  revalidateOnQueryAnyChange = false;

  async loader({ params, request }) {
    const { id } = params;

    // Get limit and search from URL query params
    const url = new URL(request.url);
    const caseNoteLimit = Number(url.searchParams.get("caseNoteLimit")) || 20;
    const caseNoteSearch = url.searchParams.get("caseNoteSearch") || undefined;

    if (!id || id === "undefined") {
      console.error("Case id not found");
      return { _case: null, notesList: [], showMoreCaseNotes: false };
    } else {
      try {
        const _case = await this.caseRepository.findRecord(id);
        const notesList = await this.caseNotesRepository.query({
          case: id,
          search: caseNoteSearch,
          skipNull: true,
          limit: caseNoteLimit,
        });
        const totalCaseNotes = await this.caseNotesRepository.getTotalCount();

        return {
          _case,
          notesList,
          showMoreCaseNotes: totalCaseNotes >= caseNoteLimit,
        };
      } catch (error) {
        console.error(`Error getting case: ${id}`, error);
        return { _case: null, notesList: [], showMoreCaseNotes: false };
      }
    }
  }
}
